import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import RoleService from "@/core/services/role.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGIN_PAGADOR = "loginPagador";
export const LOGIN_EXECUTIVE = "loginExecutive";
export const LOGOUT = "logout";
export const UPDATE_AUTH = "updateAuth";
export const UPDATE_INFO = "updateInfo";
export const UPDATE_INFO_PASSWORD = "updateInfoPassword";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  image:"",
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated && state.user && state.user.email!=null;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post({action:"/api/OAuth/v1/cliente/autenticar"}, credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"] );//response.data.errors);
        });
    });
  },
  [LOGIN_PAGADOR](context, token) {
    return new Promise(resolve => {
      ApiService.get({action:`/api/OAuth/v1/cliente/autenticar/pagadorexterno/${token}`})
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"] );//response.data.errors);
        });
    });
  },
  [LOGIN_EXECUTIVE](context, credentials) {
    return new Promise(resolve => {
      ApiService.post({action:"/api/OAuth/v1/usuario/autenticar"}, credentials)
        .then(({ data }) => {
          console.log('retorna ' + data);
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"] );//response.data.errors);
        });
    });
  },

  [UPDATE_AUTH](context, codigoEmpresa) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/api/OAuth/v1/acceso/update`},  {"codigoEmpresa": codigoEmpresa})
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR,  ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [UPDATE_INFO](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/api/OAuth/v1/acceso/updateInfo`},  user)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR,  ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [UPDATE_INFO_PASSWORD](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/api/OAuth/v1/acceso/cambiarClave`},  user)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR,  ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get({action:"/api/OAuth/v1/Me"})
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          console.log(response);
           context.commit(SET_ERROR,  ["Se ha presentado un problema al obtener su información"]);//response.data);
           context.commit(PURGE_AUTH);
         });
     } else {
       context.commit(PURGE_AUTH);
     }
   },
};

const mutations = {
 
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(state.user.token);
    RoleService.saveRole(state.user.codigoRol);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    RoleService.destroyRole();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
